import React from 'react';
import { Spinner, SpinnerSize, SpinnerVariant, CmhcFlexIcon } from '@cmhc-schl/hearth-ui';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

const serviceNowLink = (
  <a
    className="piAnchorTagExternalLinkIcon"
    href="https://cmhc.service-now.com/cmhc"
    target="_blank"
    rel="noopener noreferrer"
  >
    <u>ServiceNow</u>
  </a>
);

export const SpinnerElement = () => {
  return (
    <Box className={styles.spinnerWrapper}>
      <Spinner
        data-testid="requestOverviewSpinner"
        id="request-overview-spinner"
        size={SpinnerSize.LARGE}
        type={SpinnerVariant.PRIMARY}
        ariaText="Loading Data"
        modifiers={{ size: 20, thickness: 2 }}
      />
    </Box>
  );
};

type ErrorMessageProps = {
  errorHeader: string;
  errorContent: string;
  serviceNowRequired?: boolean;
  errorType: string;
};

const ErrorMessage = ({
  errorHeader,
  errorContent,
  serviceNowRequired = false,
  errorType
}: ErrorMessageProps) => {
  const { t } = useTranslation('HbtMasterPool');

  let iconType = 'icon_circle_x';
  let header = errorHeader;
  let contentRaw = errorContent;
  let before;
  let after;
  if (serviceNowRequired) {
    [before, after] = contentRaw.split('{{ServiceNow}}');
  }

  if (errorType === 'no_data_error') {
    iconType = 'icon_money_calculate';
  }

  return (
    <Box className={styles.portfolioErrorContainer}>
      <CmhcFlexIcon
        className={styles.moneyCalculateIcon}
        type={iconType}
        fill="transparent"
        width={48}
        height={48}
      />

      <Box className={styles.errorMessageContainer}>
        <p>
          <strong>{header}</strong>
        </p>
        {!serviceNowRequired && <p>{contentRaw}</p>}
        {serviceNowRequired && (
          <p>
            {before} {serviceNowLink} {after}
          </p>
        )}
      </Box>
    </Box>
  );
};

export default ErrorMessage;
